import {
  APP_BASE_URL,
  GET_STORIES_URL,
  GET_STORY_MOMENTS_URL,
  CREATE_STORY_URL,
  CREATE_MOMENT_URL,
  CREATE_MOMENTS_URL,
  ADD_MOMENTS_TO_STORY_URL,
  GET_MOMENT_UPLOAD_URL,
  GET_SELFIE_URL,
  GET_SELFIE_UPLOAD_URL,
  MATCH_SELFIE_URL,
  SUBMIT_SELFIE_URL,
  UPDATE_MOMENT_URL,
  API_BASE_URL,
  GET_MOMENTS_FROM_STORY_URL,
  ADD_IMAGE_TO_MOMENT_URL,
  DELETE_STORY_URL,
  GET_MOMENT_METADATA_URL,
  GET_STORY_URL,
  STORY_ACCOUNT_SETTINGS_URL,
  STORY_DOWNLOAD_URL,
  STORY_MARK_VIEWED_URL,
  STORY_CHECKOUT_SETTINGS_URL,
  RE_KNOCKOUT_MOMENT_URL,
  JOB_MARKETING_URL
} from 'shared/utils/Constants';

import { get, post, put, destroy } from 'shared/services/ApiService';

import { print, printError, getAuthToken, getLoggedInUserId } from 'shared/utils/Helpers';

export default class StoryService {
  constructor() {
  }

  processAddMomentToStory(storyId, file) {
    let momentId = null;
    return this.createMoment(file)
      .then((data) => {
        momentId = data.id;
        print("1. handleFileChange createMoment response: ", data);
        return this.addMomentsToStory(storyId, [momentId]);
      })
      .then((data) => {
        print("2. handleFileChange addMomentsToStory response: ", data);
        return this.addImageToMoment(momentId, file);
      })
      .then((data) => {
        print("3. handleFileChange getMomentUploadUrl response: ", data);
        return this.getMomentUploadUrl(momentId, file);
      })
      .then((data) => {
        print("4. handleFileChange getMomentUploadUrl response: ", data);
        let signedUrl = data.url;
        return this.uploadToGoogleApi(signedUrl, file);
      })
      .then((data) => {
        print("5. handleFileChange uploadToGoogleApi response: ", data);
        return this.updateMoment(momentId);
      })
      .then((data) => {
        print("6. handleFileChange updateMoment response: ", data);
        // this.props.onAddSuccess(this.props.story);
        return data;
      });
  }

  // API CALLS

  async getStories(mergeFamily = false) {
    // uncomment to restore cache buster
    //return get(GET_STORIES_URL);
    return await get(`${GET_STORY_URL}?merging=${mergeFamily}`);
  }

  async getStory(storyId) {
    return await get(`${GET_STORY_URL}/${storyId}`);
  }

  async getStoryMoments(storyId, page, perPage, opts) {
    return await get(GET_STORY_MOMENTS_URL(storyId, page, perPage, opts));
  }

  async createStory(params) {
    return await post(CREATE_STORY_URL, params);
  }

  async updateStory(storyId, params) {
    return await put(`${GET_STORY_URL}/${storyId}`, params);
  }

  async deleteStory(storyId) {
    return await destroy(DELETE_STORY_URL + storyId);
  }

  async downloadStory(storyId) {
    return await get(STORY_DOWNLOAD_URL(storyId));
  }

  async markStoryViewed(storyId) {
    return await put(STORY_MARK_VIEWED_URL(storyId), {});
  }

  async getAccountSettings(storyId) {
    return await get(STORY_ACCOUNT_SETTINGS_URL(storyId));
  }

  async getCheckoutSettings(storyId) {
    return await get(STORY_CHECKOUT_SETTINGS_URL(storyId));
  }

  async createMoment(params) {
    return await post(CREATE_MOMENT_URL, params);
  }

  async createMoments(storyId, files) {
    let params = { files: [] };

    for (let file of files) {
      params.files.push({
        name: file.name,
        type: file.type,
        size: file.size,
        story_id: storyId,
        hash: file.hash,
        width: file.width,
        height: file.height
      });
    }

    return await post(CREATE_MOMENTS_URL, params);
  }

  async setMomentUploaded(momentId) {
    let params = { uploaded: new Date(), preview: null };
    return await put(UPDATE_MOMENT_URL + momentId, params);
  }

  async addMomentsToStory(storyId, momentIds) {
    let params = { moment_ids: momentIds };
    return await post(ADD_MOMENTS_TO_STORY_URL + storyId, params);
  }

  async getMomentUploadUrl(momentId, fileType) {
    let params = '?as_json=true&type=' + encodeURIComponent(fileType);
    return await get(GET_MOMENT_UPLOAD_URL + momentId + params);
  }

  async getSelfieUrl(storyId) {
    return await get(GET_SELFIE_URL(storyId));
  }

  async getSelfieUploadUrl(storyId, fileType) {
    let params = '?as_json=true&type=' + encodeURIComponent(fileType);
    return await get(GET_SELFIE_UPLOAD_URL(storyId) + params);
  }

  async matchSelfie(storyId) {
    return await put(MATCH_SELFIE_URL(storyId));
  }

  async submitSelfie(storyId) {
    return await put(SUBMIT_SELFIE_URL(storyId));
  }

  async uploadToStorage(GOOGLE_API_SIGNED_URL, file) {
    return await fetch(GOOGLE_API_SIGNED_URL, {
      method: "PUT",
      credentials: "omit",
      headers: {
        "accept": "application/json, text/plain, */*",
        "content-type": file.type
      },
      body: file,
      mode: "cors"
    });
  }

  async getMomentsFromStory(storyId, page = 1, perPage = 100) {
    let params = "page=" + page + "&per_page=" + perPage + "&story_id=" + storyId;
    return await get(GET_MOMENTS_FROM_STORY_URL + params);
  }

  async getMarketingByJobId(jobId) {
    return await get(JOB_MARKETING_URL(jobId));
  }
}
